export * from './user-register-data.interface';
